import * as d3 from 'd3'

export default {
  methods: {

    draw_Values(selection) {
      let cht = this.chart
      let tube = this.tube
      let sch = this.schedule


      let tubeChart = selection
      .append('g')
      .attr('transform', `translate(.5, .5)`)

      // Progress
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness / 2},${tube.height + this.base.textY + this.actual.pro.tSize*0.36})`)
      .attr('font-size', this.actual.pro.tSize).attr('font-weight', 400).attr('fill', this.actual.pro.tColor)
      .attr('text-anchor', 'middle')
      .text(`${this.rawData.ACT_CUM}%`)

      // This Week
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness /2},${cht.scale(100) + this.actual.week.tSize*0.36})`)
      .attr('font-size', this.actual.week.tSize).attr('fill', this.actual.week.tColor)
      .attr('text-anchor', 'middle')
      .text(`${this.rawData.ACT_WK}%`)

      tubeChart
      .append('line')
      .attr('x1', tube.tickness).attr('y1', cht.scale(100))
      .attr('x2', tube.tickness + 30).attr('y2', cht.scale(100))
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      tubeChart
      .append('circle')
      .attr('cx', tube.tickness + 30).attr('cy', cht.scale(100))
      .attr('r', 2.5).attr('fill', '#bcbcbc')

      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness + 38},${cht.scale(100) + sch.title.tSize*0.36})`)
      .attr('font-size', sch.title.tSize).attr('fill', sch.title.tColor)
      .attr('text-anchor', 'start')
      .text(`This Week`)

      // Culmulative
      tubeChart
      .append('line')
      .attr('x1', tube.tickness).attr('y1', cht.scale(this.rawData.ACT_CUM))
      .attr('x2', tube.tickness + 15).attr('y2', cht.scale(this.rawData.ACT_CUM))
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      tubeChart
      .append('line')
      .attr('x1', tube.tickness + 15).attr('y1', cht.scale(30))
      .attr('x2', tube.tickness + 30).attr('y2', cht.scale(30))
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      tubeChart
      .append('line')
      .attr('x1', tube.tickness + 15).attr('y1', cht.scale(30))
      .attr('x2', tube.tickness + 15).attr('y2', cht.scale(this.rawData.ACT_CUM))
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      tubeChart
      .append('circle')
      .attr('cx', tube.tickness + 30).attr('cy', cht.scale(30))
      .attr('r', 2.5).attr('fill', '#bcbcbc')
      
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness + 38},${cht.scale(30) + sch.title.tSize*0.4})`)
      .attr('font-size', sch.title.tSize).attr('fill', sch.title.tColor)
      .attr('text-anchor', 'start')
      .text(`Culmulative`)

      this.draw_schedule(selection, 'WK', tube.tickness + 40, cht.scale(90)) // -----> draw.Schedule.js 
      this.draw_schedule(selection, 'CUM', tube.tickness + 40, cht.scale(20)) // -----> draw.Schedule.js 
    },




    
  }
}